module.exports = "./img/cb39536dad94ff0d3f4db834e59c86d7.jpg";